import { useState } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import {
  DateFilterKey,
  DateRange,
  isDateRangeInverted
} from "../../utils/dateRanges";
import { DateRangeFields } from "./DateRangeFields";

export const DateRangeFilterPanel = ({
  title,
  dateKey,
  range,
  onApply,
  onCancel
}: {
  title: string;
  dateKey: DateFilterKey;
  range?: DateRange;
  onApply: (range?: DateRange) => void;
  onCancel: () => void;
}) => {
  const [draft, setDraft] = useState<DateRange>(range ?? {});
  const isInverted = isDateRangeInverted(draft);

  return (
    <div className="w-[352px] space-y-3 p-4">
      <p className="text-sm font-bold text-content-1000">{title}</p>

      <DateRangeFields
        idPrefix="column-filter"
        dateKey={dateKey}
        range={draft}
        onChange={setDraft}
      />

      <div className="flex items-center justify-between border-t border-alpha-40 pt-3">
        <button
          type="button"
          className="text-xs font-bold text-content-500"
          onClick={() => setDraft({})}
        >
          Clear
        </button>
        <div className="flex gap-2">
          <Button size={ButtonSize.SM} onClick={onCancel}>
            Cancel
          </Button>
          <Button
            size={ButtonSize.SM}
            variant={ButtonVariant.PRIMARY}
            disabled={isInverted}
            onClick={() => onApply(draft.from || draft.to ? draft : undefined)}
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};
